import { Box } from '@components/ui/atoms/Box';
import { Flex } from '@components/ui/atoms/Flex';
import { Text } from '@components/ui/atoms/Text';

import type { Notification } from '../../NotificationModal/types';
import { NotificationItem } from './NotificationItem';

interface NotificationGroupProps {
  title: string;
  notifications: Notification[];
  selectedId: string | null;
  onSelectNotification: (notification: Notification) => void;
}

export const NotificationGroup: React.FC<NotificationGroupProps> = ({
  title,
  notifications,
  selectedId,
  onSelectNotification,
}) => {
  if (notifications.length === 0) {
    return null;
  }

  return (
    <Box>
      <Flex p="16px 20px" borderBottom="1px solid" borderColor="body.550/10">
        <Text fontSize="14px" fontWeight="600" color="title.dark">
          {title}
        </Text>
      </Flex>
      <Box>
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            isSelected={notification.id === selectedId}
            onClick={() => {
              onSelectNotification(notification);
            }}
          />
        ))}
      </Box>
    </Box>
  );
};
